import axios from "axios"
import setup, {SLIDER_INIT_TYPES} from "../../setup"
interface ILinkItem {
  element: HTMLAnchorElement
  href: string
}
interface ILink {
  [hash: string]: ILinkItem
}
interface IParseResult {
  title: string
  root: JQuery.Node
}
type Events = "pageloaded" | "pageloading"

export default class AsyncPage {
  private links: ILink = {}
  private containerRoot: JQuery<HTMLElement>
  private rootId: string

  constructor(rootId: string) {
    this.init(SLIDER_INIT_TYPES.CONSTRUCTOR);
    this.rootId = rootId;
    this.containerRoot = $(`#${rootId}`);
    this.addEventListener("pageloaded", () => {
      this.init(SLIDER_INIT_TYPES.PAGE_LOADED);
    });
    window.addEventListener("popstate", (event) => {
      if (!window.location.href.includes("#")) {
        event.preventDefault();
        event.stopPropagation();
        this.loadPage(window.location.href);
      }
    });
  }

  private init(caller: string) {
    setup(caller)
    document.querySelectorAll('a:not([target],.ui-datepicker-prev,.ui-datepicker-next,td.has-archive a, [href*="send-message.html"], .not-async-link)').forEach(element => {
      const $element = $(element)
      let anchor  = <HTMLAnchorElement><any>$element 
      if (anchor[0].host == window.location.host)
      {
      const href = $element.attr("href") || ""
      $element.on('click', async (event) => {
        event.stopPropagation();
        event.preventDefault();
        window.history.pushState('', '', $element.attr("href"));
        console.log('async init')
        let resetScroll = $element.attr('data-media-path') || $element.parents('#calendar').length ? false : true;
        await this.loadPage($element.attr("href"), resetScroll);
      })
    } else {
      anchor[0].target = '_blank';
    }
    })

    document.querySelectorAll("#on-air-play-button").forEach(element => {
      const $element = $(element)
      $element.on('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.history.pushState('', '', $element.attr("data-href"));
        await this.loadPage($element.attr("data-href"), false);
      })
    })

  }

  private parsePage(data: string): IParseResult {
    const startIndex = data.indexOf("<body>")
    const endIndex = data.lastIndexOf("</body>")
    if (!startIndex || !endIndex) {
      throw new Error("Invalid html")
    }

    const title = data.substring(
      data.indexOf("<title>") + "<title>".length,
      data.indexOf("</title>")
    )
    const body = data.substring(startIndex + 6, endIndex)

    const html = $.parseHTML(body, document, true)

    const root = html.find((value: HTMLElement) => {
      return value.id == this.rootId
    })

    return {
      root,
      title
    }
  }

  public async loadPage(href: string, resetScroll = true) {
    this.dispatchEvent("pageloading")
    const responce = await axios.get(href)
    const contentType: string = responce.headers["content-type"]

    if (!new RegExp(/text\/html/).test(contentType)) {
      throw new Error("Invalid responce")
    }

    const data: string = responce.data
    const { root, title } = this.parsePage(data)
    function htmlDecode(input) {
      var doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    }
    let unescTitle = htmlDecode(title)
    document.title = title ? unescTitle : document.title


    if (!root) {
      throw new Error("root container not found")
    }

    this.containerRoot.html($(root).html())

    if (resetScroll) {
      window.scrollTo(0, 0)
    }
    this.dispatchEvent("pageloaded")
  }

  public addEventListener(type: Events, callback) {
    document.addEventListener(type, callback)
  }

  private dispatchEvent(type: Events) {
    document.dispatchEvent(new Event(type))
  }
}
